"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProjectTypeOptions = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const featureFlags_1 = require("../../../common/featureFlags");
const localizeUtils_1 = require("../../../common/localizeUtils");
const constants_1 = require("../../constants");
class ProjectTypeOptions {
    static groupName(group) {
        switch (group) {
            case constants_1.ProjectTypeGroup.AIAgent:
                return (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.createGroup.aiAgent");
            case constants_1.ProjectTypeGroup.M365Apps:
                return (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.createGroup.m365Apps");
        }
    }
    static tab(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.tabOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(browser) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.TabOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.tab.detail"),
            groupName: ProjectTypeOptions.groupName(constants_1.ProjectTypeGroup.M365Apps),
        };
    }
    static bot(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.botOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(hubot) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.bot.detail"),
            groupName: ProjectTypeOptions.groupName(constants_1.ProjectTypeGroup.M365Apps),
        };
    }
    static me(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.meOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(symbol-keyword) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.MessageExtensionOption.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.messageExtension.copilotEnabled.detail"),
            groupName: ProjectTypeOptions.groupName(constants_1.ProjectTypeGroup.M365Apps),
        };
    }
    static outlookAddin(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.outlookAddinOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(mail) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.outlookAddin.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.outlookAddin.detail"),
            groupName: ProjectTypeOptions.groupName(constants_1.ProjectTypeGroup.M365Apps),
        };
    }
    static officeMetaOS(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.officeMetaOSOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-m365) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.officeAddin.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.officeAddin.detail"),
            groupName: ProjectTypeOptions.groupName(constants_1.ProjectTypeGroup.M365Apps),
        };
    }
    static officeAddin(platform = teamsfx_api_1.Platform.VSCode) {
        if (featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.OfficeMetaOS)) {
            return this.officeMetaOS(platform);
        }
        else {
            return this.outlookAddin(platform);
        }
    }
    static declarativeAgent(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.copilotAgentOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-agent) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.declarativeAgent.detail"),
            groupName: ProjectTypeOptions.groupName(constants_1.ProjectTypeGroup.AIAgent),
        };
    }
    static customEngineAgent(platform = teamsfx_api_1.Platform.VSCode) {
        return {
            id: ProjectTypeOptions.customCopilotOptionId,
            label: `${platform === teamsfx_api_1.Platform.VSCode ? "$(teamsfx-custom-copilot) " : ""}${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.customCopilot.detail"),
            groupName: ProjectTypeOptions.groupName(constants_1.ProjectTypeGroup.AIAgent),
        };
    }
    static startWithGithubCopilot() {
        const description = featureFlags_1.featureFlagManager.getBooleanValue(featureFlags_1.FeatureFlags.HideGitHubCopilotPreviewTag)
            ? undefined
            : (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.option.description.preview");
        return {
            id: ProjectTypeOptions.startWithGithubCopilotOptionId,
            label: `$(comment-discussion) ${(0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotHelp.label")}`,
            detail: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotHelp.detail"),
            groupName: (0, localizeUtils_1.getLocalizedString)("core.createProjectQuestion.projectType.copilotGroup.title"),
            description,
        };
    }
}
exports.ProjectTypeOptions = ProjectTypeOptions;
ProjectTypeOptions.tabOptionId = "tab-type";
ProjectTypeOptions.botOptionId = "bot-type";
ProjectTypeOptions.meOptionId = "me-type";
ProjectTypeOptions.outlookAddinOptionId = "outlook-addin-type";
ProjectTypeOptions.officeMetaOSOptionId = "office-meta-os-type";
ProjectTypeOptions.copilotAgentOptionId = "copilot-agent-type";
ProjectTypeOptions.customCopilotOptionId = "custom-copilot-type";
ProjectTypeOptions.startWithGithubCopilotOptionId = "start-with-github-copilot";
//# sourceMappingURL=ProjectTypeOptions.js.map